import type { Client } from 'openapi-fetch';

import type { EmsPaths } from '../api/ems';
import type { GeoPoint } from '../realtime';

export type AgencyConfigurationDto =
  EmsPaths['/portal/v1/configuration']['get']['responses'][200]['content']['application/json'];

export type AgencyPortalConfigurationDto = AgencyConfigurationDto['agencyPortalConfiguration'];

export type AgencyPortalFeaturesDto = AgencyPortalConfigurationDto['agencyPortalFeatures'];

export type PortalAgencyInfo = {
  id: string;
  displayName: string;
  position: GeoPoint | null;
};

export async function fetchAgencyConfiguration(emsApi: Client<EmsPaths>): Promise<AgencyConfigurationDto> {
  const { data, response } = await emsApi.GET('/portal/v1/configuration');

  if (data === undefined) {
    throw new Error(`Failed to load agency configuration (HTTP ${response.status})`);
  }

  return data;
}

export function getRelatedAgenciesForSharing(agencyConfiguration: AgencyConfigurationDto): PortalAgencyInfo[] {
  return (agencyConfiguration.relatedAgencies ?? []).map((agency) => ({
    id: agency.id ?? '',
    displayName: agency.displayName ?? '',
    position:
      agency.position?.latitude != null && agency.position.longitude != null
        ? { latitude: agency.position.latitude, longitude: agency.position.longitude }
        : null,
  }));
}
